// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import * as React from "react"; // Greif Custom Code
import { css, useTheme } from "styled-components";

/* Starter Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import SizedWrapper, {
    sizedWrapperImageStyles,
    SizedWrapperStyles,
} from "@store/Library/Components/Toolkit/SizedWrapper";
/* Starter Custom Code - End */

/* Greif Custom Code - Start */
// import {
//     headerHideForDesktopStyles,
//     headerHideForMobileStyles,
//     headerMobileSelector,
// } from "@store/Themes/common/mixins/header";
/* Greif Custom Code - End */

/* Starter Custom Code - Start */
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getPreviousBreakpoint from "@toolkit/Framework/Common/Utilities/getPreviousBreakpoint";
import getValuesToBreakpoint from "@toolkit/Framework/Common/Utilities/getValuesToBreakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useHeaderPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
/* Starter Custom Code - End */

/* Greif Custom Code - Start */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Modal, { ModalPresentationProps } from "@store/MobiusOverrides/Modal/Modal";
import useHeader from "@store/Framework/Components/Header/useHeader";
import setChangeCustomerModalIsOpen from "@store/Framework/Store/Greif/Components/ChangeCustomerModal/Handlers/ChangeCustomerIsOpen";
import {
    headerHideForDesktopStyles,
    headerHideForMobileStyles,
    headerMobileSelector,
} from "@store/Themes/common/mixins/header";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
/* Greif Custom Code - End */

/* Starter Custom Code - Start */
const zoneWrapperStyles = () => css`
    max-height: inherit;

    > div /* Zone */ {
        max-height: inherit;
    }
`;
/* Starter Custom Code - End */

/* Greif Custom Code - Start */
const enum fields {
    forceModalOpen = "forceModalOpen",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.forceModalOpen]: boolean;
    };
}

const mapPropsToState = (state: ApplicationState) => ({
    changeCustomerModalIsOpen: state.greif.components.changeCustomerModal.isOpen,
});

const mapDispatchToProps = {
    setChangeCustomerModalIsOpen,
};

type Props = OwnProps & PageProps & ReturnType<typeof mapPropsToState> & ResolveThunks<typeof mapDispatchToProps>;
/* Greif Custom Code - End */

export interface LogoLinksSearchStyles {
    /* Starter Custom Code - Start */
    sizedWrapper?: SizedWrapperStyles;
    wrapper?: InjectableCss;
    navWrapper?: InjectableCss;
    logoWrapper?: InjectableCss;
    searchWrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    /* Starter Custom Code */
    // Greif Custom Code
    navigationWrapper?: InjectableCss;
    desktopNavigationWrapper?: InjectableCss;
    changeCustomerModal?: ModalPresentationProps;
}

/* Greif Custom Code - Start */
const itemSpacing = () => css`
    ${({ theme }) => {
        return breakpointValues(theme.design.header.itemSpacing.map(x => contentSpacingStyles(0, x, 0)));
    }}
`;
/* Greif Custom Code - End */

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    sizedWrapper: {
        wrapper: {
            css: css`
                background-color: ${getColor("header")};
                color: ${getColor("header.contrast")};
                transform: translateZ(0);

                ${headerMobileSelector()} {
                    box-shadow: ${x => x.theme.shadows["1"]}; /* Greif Custom Code */
                }
            `,
        },
        content: {
            css: siteWidthStyles(),
        },
    },
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-grow: 1;
            max-height: inherit;
            ${x => breakpointValues(x.theme.design.header.itemSpacing, "column-gap")}

            ${({ theme }) => {
                return breakpointValues(
                    getValuesToBreakpoint(
                        theme.design.header.iconButton.padding,
                        getPreviousBreakpoint(theme.design.header.breakpoint, theme),
                        theme,
                    ).map(x => (x ? `-${x}` : x)),
                    ["margin-right", "margin-left"],
                );
            }}

            position: relative; /* Greif Custom Code */
        `,
    },
    navWrapper: {
        css: css`
            ${headerHideForDesktopStyles()}
            ${zoneWrapperStyles()}
            flex-grow: 1;
        `,
    },
    logoWrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            ${zoneWrapperStyles()}
            ${sizedWrapperImageStyles()}
            flex-grow: 1; /* Greif Custom Code */
        `,
    },
    searchWrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            ${zoneWrapperStyles()}
            /* Greif Custom Code - Start */
            ${itemSpacing()}
            max-width: ${pxToRem(440)};
            flex-grow: 1;

            /* Greif Custom Code - End */
        `,
    },
    /* Greif Custom Code - Start */
    desktopNavigationWrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            ${zoneWrapperStyles()}
             ${itemSpacing()}
             flex-grow: 0;
        `,
    },
    /* Greif Custom Code - End */
    contentWrapper: {
        css: css`
            ${zoneWrapperStyles()}
            ${itemSpacing()} // Greif
            > div /* Zone */ {
                display: flex;
                align-items: center;
                ${x => breakpointValues(x.theme.design.header.subItemSpacing, "column-gap")}
            }
        `,
    },
    /* Greif Custom Code - Start */
    navigationWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex-grow: 2;

            ${headerMobileSelector()} {
                flex-grow: 0;
            }
        `,
    },
    changeCustomerModal: {
        sizeVariant: "medium",
        cssOverrides: {
            modalContent: css`
                min-height: ${pxToRem(400)};
                > div {
                    position: absolute;
                    max-width: calc(100% - 60px);
                    margin-top: 10px;
                }
            `,
            modalBody: css`
                overflow-y: visible;
            `,
        },
        mergeCss: true,
    },
    /* Greif Custom Code - End */
};

const styles = logoLinksSearchStyles; // Starter Custom Code

const LogoLinksSearch: React.FC<Props> = ({
    id,
    fields,
    // Greif Custom Code
    changeCustomerModalIsOpen,
    setChangeCustomerModalIsOpen,
}) => {
    /* Starter Custom Code */
    const headerPage = useHeaderPage();
    const theme = useTheme();

    /* Greif Custom Code - Start */
    const { headerHeights, headerPaddings } = useHeader();
    const modalCloseHandler = () => setChangeCustomerModalIsOpen({ isOpen: false });

    useEffect(() => {
        setChangeCustomerModalIsOpen({ isOpen: fields.forceModalOpen });
    }, []);
    /* Greif Custom Code - End */

    return (
        <>
            {/* Greif Custom Code - Start */}
            <Modal
                {...styles.changeCustomerModal}
                headline={translate("Change Account")}
                isOpen={changeCustomerModalIsOpen}
                handleClose={modalCloseHandler}
            >
                <Zone zoneName="ChangeAccount" contentId={id} />
            </Modal>
            {/* Greif Custom Code - End */}
            <SizedWrapper
                heights={headerHeights /* Greif */}
                paddings={headerPaddings /* Greif */}
                extendedStyles={styles.sizedWrapper}
            >
                <StyledWrapper {...styles.wrapper}>
                    <StyledWrapper {...styles.navWrapper} data-zone-single>
                        <Zone contentId={id} zoneName="Navigation" /* Greif Custom Code */ />
                    </StyledWrapper>
                    <StyledWrapper {...styles.logoWrapper} data-zone-single>
                        <Zone contentId={id} zoneName="Logo" /* Greif Custom Code */ />
                    </StyledWrapper>
                    {/* Greif Custom Code - Start */}
                    <StyledWrapper {...styles.navigationWrapper}>
                        <StyledWrapper {...styles.desktopNavigationWrapper} data-zone-single>
                            <Zone contentId={id} zoneName="Navigation" />
                        </StyledWrapper>
                        <StyledWrapper {...styles.searchWrapper} data-zone-single>
                            <Zone contentId={id} zoneName="Search" />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contentWrapper}>
                            <Zone contentId={id} zoneName="Content" />
                        </StyledWrapper>
                    </StyledWrapper>
                    {/* Greif Custom Code - End */}
                </StyledWrapper>
            </SizedWrapper>
        </>
    );
    /* Starter Custom Code - End */
};

const logoLinksSearch: WidgetModule = {
    component: connect(mapPropsToState, mapDispatchToProps)(LogoLinksSearch), // Greif Custom Code
    definition: {
        group: "Common",
        icon: "magnifying-glass",
        allowedContexts: ["Header"], // Starter Custom Code
        // Greif Custom Code
        fieldDefinitions: [
            {
                name: fields.forceModalOpen,
                displayName: "Force Modal Open",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 9,
            },
        ],
    },
};

export default logoLinksSearch;
